import { render, staticRenderFns } from "./TabReceive.vue?vue&type=template&id=6b1a41b5&"
import script from "./TabReceive.vue?vue&type=script&lang=js&"
export * from "./TabReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports